<template>
  <div>
    <div class="header-function-box">
      <div class="search-box" v-show="searchShow" style="float:left;width: 70%">
        <el-input
          style="width: 30%;margin-right: 10px"
          placeholder="请输入任务名称..."
          size="small"
          prefix-icon="el-icon-search"
          clearable
          @clear="clearTaskName"
          v-model="searchCondition.taskName">
        </el-input>
        <el-select v-model="searchCondition.isFinished"
                   size="small"
                   @clear="clearTaskStatus"
                   placeholder="请选择状态">
          <el-option :key="1" label="已完成" :value="true"/>
          <el-option :key="2" label="未完成" :value="false"/>
          <el-option :key="3" label="所有" :value="null"/>
        </el-select>

        <!-- 选择接收者 -->
        <el-select v-if="isOrdinaryConsumer !== true"
                   v-model="searchCondition.receiverId"
                   size="small"
                   filterable
                   @focus="setConsumerNameAndIdForSearch"
                   :loading="consumerNameAndIdForSearch.loading"
                   placeholder="请选择用户">
          <el-option
            v-for="item in consumerNameAndIdForSearch.list"
            :key="item.userId"
            :label="item.nickname"
            :value="item.userId">
          </el-option>
        </el-select>

        <el-button type="primary"
                   size="small"
                   icon="el-icon-search"
                   @click="searchTask"
                   style="margin-left: 10px">搜索
        </el-button>

      </div>

      <!-- 按钮栏 -->
      <div class="button-box" style="float: right;margin-right: 10px">
        <el-tooltip content="刷新数据" placement="bottom">
          <el-button type="success" size="small" plain circle icon="el-icon-refresh" @click="initTask"/>
        </el-tooltip>
        <el-button v-if="isOrdinaryConsumer === true && forReview === false && readOnly === false"
                   type="primary" size="small"
                   @click="storeHouseFileUploadDialogVisible = true;storeHouseFileUpload.type = 1">提交订单文件
        </el-button>
        <el-button v-if="isOrdinaryConsumer === true && forReview === false && readOnly === false"
                   type="success" size="small"
                   @click="storeHouseFileUploadDialogVisible = true;storeHouseFileUpload.type = 2">提交贴纸文件
        </el-button>
        <el-button v-if="isOrdinaryConsumer === false && forReview === false && readOnly === false"
                   type="warning" size="small"
                   @click="publishDialogFormVisible = true;">发布任务
        </el-button>
      </div>
    </div>


    <el-table
      v-loading="loading"
      :data="taskList"
      style="width: 100%"
      :row-style="rowStyle">
      <el-table-column
        sortable
        prop="id"
        label="任务id"
        min-width="8.285%">
      </el-table-column>
      <el-table-column
        prop="name"
        label="任务名"
        :show-overflow-tooltip="true"
        min-width="20.285%">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
          <el-button size="mini"
                     style="padding:7px;"
                     icon="el-icon-document-copy"
                     v-clipboard:copy="scope.row.name"
                     v-clipboard:success="onCopySuccess">
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="任务状态"
        :show-overflow-tooltip="true"
        min-width="10%">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === '审核中'" type="">{{ scope.row.status }}</el-tag>
          <el-tag v-else-if="scope.row.status === '进行中'" type="success">{{ scope.row.status }}</el-tag>
          <el-tag v-else-if="scope.row.status === '已结束'" type="danger">{{ scope.row.status }}</el-tag>
          <el-tag v-else type="warning">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="score"
        label="分数"
        min-width="10%">
      </el-table-column>
      <el-table-column v-if="!isOrdinaryConsumer"
                       sortable
                       prop="receiverName"
                       label="接收者"
                       min-width="10.285%">
        <template slot-scope="scope">
          <span>{{ scope.row.receiverName }}</span>
          <el-button size="mini"
                     style="padding:7px;"
                     icon="el-icon-document-copy"
                     v-clipboard:copy="scope.row.receiverName"
                     v-clipboard:success="onCopySuccess">
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        :show-overflow-tooltip="true"
        label="备注"
        min-width="14.285%">
      </el-table-column>
      <el-table-column
        sortable
        prop="gmtCreate"
        label="发布时间"
        min-width="18.285%">
      </el-table-column>
      <el-table-column
        sortable
        prop="publisherName"
        label="发布者"
        min-width="10.285%">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        min-width="14.285%">
        <template slot-scope="scope">
          <!-- 推进 -->
          <el-button type="primary"
                     style="margin-left: 5px"
                     circle
                     icon="el-icon-check"
                     size="small"
                     @click="setPushDialog(scope.row)">
          </el-button>
          <!-- 显示日志 -->
          <el-popover
            style="margin-left: 5px"
            placement="left"
            width="300"
            trigger="click">
            <el-timeline v-loading="taskLogs.loading"
                         style="padding-left: 10px;margin-top: 10px;padding-right:10px;max-height:600px;overflow-y: auto">
              <el-timeline-item
                v-for="(taskLog, index) in taskLogs.list"
                :key="index"
                :icon="taskLog.icon"
                :size="taskLogs.size"
                :color="taskLog.color"
                :timestamp="taskLog.timestamp">
                <el-card body-style="padding: 10px">
                  <h4>由 {{ taskLog.operatorName }} 提交 {{ taskLog.success }}</h4>
                  <p><strong>{{ taskLog.operationName }}</strong>：{{ taskLog.content }}</p>
                  <div v-if="taskLog.withFile">
                    <el-button v-for="(fileLogId,index) in taskLog.fileLogIdList"
                               :key="index"
                               type="text"
                               @click="downLoadFileInTask(fileLogId)">
                      文件{{ fileLogId }}
                    </el-button>
                  </div>
                </el-card>
              </el-timeline-item>
            </el-timeline>
            <el-button type="info"
                       circle
                       icon="el-icon-s-order"
                       size="small"
                       slot="reference"
                       @click="taskLogDialogVisible = true;showTaskLog(scope.row)">
            </el-button>
          </el-popover>
          <!-- 删除 -->
          <el-button v-if="isOrdinaryConsumer === false && forReview === false && readOnly === false"
                     type="danger"
                     style="margin-left: 5px"
                     circle
                     icon="el-icon-close"
                     size="small"
                     @click="deleteTask(scope.row)">
          </el-button>

          <el-button v-if="isOrdinaryConsumer === true && forReview === false && readOnly === false"
                     type="success"
                     style="margin-left: 5px;"
                     circle
                     icon="el-icon-caret-right"
                     size="small"
                     @click="startTask(scope.row)">
          </el-button>

          <color-select v-model="tempColor" style="width: 50px" @update="colorChange(scope.row)"></color-select>

        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="page"
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page="current"
      :page-sizes="[8, 16, 32]"
      :page-size="32"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <!-- 推进表单 -->
    <el-dialog title="任务操作" :visible.sync="pushDialogFormVisible" append-to-body>
      <el-form :model="pushForm">
        <el-form-item label="任务id" :label-width="formLabelWidth">
          <el-input v-model="pushForm.taskId" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务名" :label-width="formLabelWidth">
          <el-input v-model="pushTaskName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="推进操作" :label-width="formLabelWidth">
          <el-select v-model="pushForm.operationCode" placeholder="请选择">
            <el-option v-if="forReview === false && userInfo.consumerLevel !== '客服' && readOnly === false"
                       label="推进" value="0"></el-option>
            <el-option label="报备" value="1"></el-option>
            <el-option
              v-if="isOrdinaryConsumer === false && forReview === false && userInfo.consumerLevel !== '客服' && readOnly === false"
              label="转让" value="5"></el-option>
            <el-option v-if="forReview === false && userInfo.consumerLevel !== '客服' && readOnly === false"
                       label="递交审核" value="6"></el-option>
            <el-option v-if="forReview !== false" label="审核通过" value="2"></el-option>
            <el-option v-if="forReview !== false" label="打回" value="7"></el-option>
            <el-option v-if="forReview === false && userInfo.consumerLevel !== '客服' && readOnly === false"
                       label="放弃任务" value="8"></el-option>
            <el-option v-if="isOrdinaryConsumer === false && forReview === false && readOnly === false" label="重新入库"
                       value="10"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="pushForm.remark"
                    type="textarea"
                    :rows="2"
                    placeholder="备注"></el-input>
        </el-form-item>
        <el-form-item v-if="readOnly === false" label="上传文件" :label-width="formLabelWidth">
          <el-upload
            ref="upload"
            class="upload-demo"
            drag
            :action="this.uploadUrl"
            :before-upload="checkFile"
            :on-success="onUploadSuccess"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!--            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pushDialogFormVisible = false;clearPushForm()">取 消</el-button>
        <el-button type="primary" @click="pushDialogFormVisible = false;push()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 发布任务 -->
    <el-dialog title="发布任务" :visible.sync="publishDialogFormVisible" append-to-body
               v-if="isOrdinaryConsumer === false && readOnly === false">
      <el-form :model="publishTaskForm">
        <el-form-item label="任务名" :label-width="formLabelWidth">
          <el-input v-model="publishTaskForm.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="指定任务接收者" :label-width="formLabelWidth">
          <el-select v-model="publishTaskForm.receiverId"
                     placeholder="请选择"
                     filterable
                     @focus="setConsumerNameAndIdForPublish"
                     :loading="consumerNameAndIdForPublish.loading">
            <el-option
              v-for="item in consumerNameAndIdForPublish.list"
              :key="item.userId"
              :label="item.nickname"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="任务所在组" :label-width="formLabelWidth">
          <el-select v-model="publishTaskForm.group"
                     placeholder="请选择"
                     filterable
                     @focus="setGroupForPublish"
                     :loading="groupForPublish.loading">
            <el-option
              v-for="item in groupForPublish.list"
              :key="item.id"
              :label="item.groupName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否进入仓库" :label-width="formLabelWidth">
          <el-checkbox v-model="publishTaskForm.toStoreHouse">进入仓库</el-checkbox>
        </el-form-item>
        <el-form-item label="任务优先级" :label-width="formLabelWidth">
          <el-select v-model="publishTaskForm.level" placeholder="请选择">
            <el-option
              v-for="item in taskLevels"
              :key="item.key"
              :label="item.label"
              :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="快捷备注" :label-width="formLabelWidth">
          <el-checkbox-group v-model="publishTaskForm.quickNoteId">
            <el-checkbox-button v-for="quickNote in quickNotes"
                                :label="quickNote.id"
                                :key="quickNote.id"
                                border>
              {{ quickNote.content }}
            </el-checkbox-button>
          </el-checkbox-group>

        </el-form-item>

        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="publishTaskForm.remark"
                    type="textarea"
                    :rows="2"
                    placeholder="备注"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="publishDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="publishTask()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 仓库文件上传 -->
    <el-dialog title="仓库文件上传" :visible.sync="storeHouseFileUploadDialogVisible" append-to-body
               v-if="isOrdinaryConsumer === true && readOnly === false">
      <el-tabs v-model="uploadActiveName">
        <el-tab-pane label="普通文件上传" name="common">
          <el-form>
            <el-form-item label="仓库文件上传" :label-width="formLabelWidth">
              <el-upload
                ref="upload"
                class="upload-demo"
                drag
                :action="this.uploadUrl"
                :before-upload="checkFile"
                :on-success="onStoreHouseFileSuccess"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <!--            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
              </el-upload>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="大文件上传" name="big">
          <el-form>
            <el-form-item label="大文件上传" :label-width="formLabelWidth">
              <el-upload
                ref="upload"
                class="upload-demo"
                drag
                action=""
                :limit="1"
                :http-request="handleAuthUpload"
                :before-remove="removeAuthUpload"
                :on-error="onFileUploadError"
                :on-exceed="handleExceed"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">一次只能上传一个文件，文件大小没有上限</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

  </div>
</template>

<script>
import {
  deleteTask,
  getUploadUrl,
  listTask,
  listTaskLog,
  pushTask,
  taskPublish,
  updateTaskSetting
} from "../../../api/task/task";
import {resultCheck} from "../../../utils/result"
import {mapState} from "vuex";
import {messageInfo} from "../../../utils/MessageInfo";
import {getRequest} from "../../../utils/request";
import {strIsEmpty} from "../../../utils/common";
import {forStoreFile, getAuthURL, getDownloadUrlNotDecreaseScore} from "../../../api/file/file";
import {listQuickNotes} from "../../../api/task/quickNote";
import ColorSelect from "../myComponent/ColorSelect";
import axios from "axios";
import OSS from "ali-oss";

export default {
  name: "MyTask",
  components: {ColorSelect},
  created() {
    // 上传url
    this.uploadUrl = getUploadUrl();
    // 任务的颜色设置
    this.tempColor = "rgba(255,255,255,0)"
    // 加载每个人的id 和 name
    this.setConsumerNameAndIdForPublish();
    this.setConsumerNameAndIdForSearch();
    // 加载组别
    this.setGroupForPublish();
    // 加载快捷备注
    this.getQuickNotes();
    // 如果是普通用户
    if (this.isOrdinaryConsumer === true) {
      // 只能查找自己的任务
      this.searchCondition.receiverId = this.userInfo.userId;
    } else if (!this.forReview) {
      // 如果不是审核模块
      if (this.operation === 'publish') {
        // 如果 是通过快捷键来的，url中带有参数
        // 则显示 发布任务 的 窗口
        this.publishDialogFormVisible = true;
      }
    } else {
      // 如果是审核
      this.searchCondition.underReview = true;
    }
    // if (this.userInfo.consumerLevel === '管理员' || this.userInfo.consumerLevel === '超级管理员') {
    //   this.assignReceiverDisabled = false;
    // }
    this.searchCondition.isFinished = false;
    this.searchCondition.taskName = '';
    this.initTask();
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  comments: {
    ColorSelect
  },
  props: ["isOrdinaryConsumer", "operation", "forReview", "readOnly"],
  data() {
    return {
      loading: true,
      publishDialogFormVisible: false,
      pushDialogFormVisible: false,
      taskLogDialogVisible: false,
      storeHouseFileUploadDialogVisible: false,
      storeHouseFileUpload: {
        type: 0,
      },
      tempColor: null,
      // 上传文件 tab activeName
      uploadActiveName: 'common',
      // 查找任务 返回值
      taskList: [
        // {
        //   id: "123123",
        //   name: "hh task",
        //   publisherName: "hh",
        //   remark: "test",
        //   gmtCreate: "2021/1/15 14:09"
        // }
      ],
      uploadUrl: "",
      // 发布任务
      publishTaskForm: {
        name: '',
        remark: '',
        receiverId: -1,
        operationCode: 3,
        toStoreHouse: true,
        operatorId: '',
        publisherName: '',
        level: 0,
        quickNoteId: [],
        group: 0,
      },
      taskLevels: [
        {key: 0, label: '普通'},
        {key: 1, label: '加急'},
        {key: 2, label: '大件'},
      ],
      // 推进任务
      pushTaskName: '',
      pushForm: {
        taskId: '',
        operationCode: '6',
        operatorId: '',
        remark: '',
        withFile: false,
        fileLogIds: "",
        quickNoteId: null
      },
      formLabelWidth: '120px',
      // 文件上传
      fileList: [],
      // 查询 任务
      searchShow: true,   //查询功能是否开启
      searchCondition: {   //查询条件
        taskName: '',
        // 默认是未结束的任务
        isFinished: false,
        receiverId: -1,
        underReview: null,
        size: 32,
        current: 1
      },
      // 分页
      total: 0,
      current: 1,
      // taskLog
      taskLogs: {
        list: [],
        loading: false,
        title: "标题",
        size: "large"
      },
      // 用户 name 与 id
      consumerNameAndId: {
        // hasList 代表已经加载了
        hasList: false,
        list: [
          {
            userId: -1,
            nickname: '由系统分配'
          }
        ],
        loading: false
      },
      // 发布任务的用户列表
      consumerNameAndIdForPublish: {
        // hasList 代表已经加载了
        hasList: false,
        list: [
          {
            userId: -1,
            nickname: '由系统分配'
          }
        ],
        loading: false
      },
      groupForPublish: {
        hasList: false,
        list: [
          {
            id: 0,
            groupName: '所有人',
          }
        ],
        loading: false
      },
      // 搜索的用户列表
      consumerNameAndIdForSearch: {
        // hasList 代表已经加载了
        hasList: false,
        list: [
          {
            userId: -1,
            nickname: '由系统分配'
          }
        ],
        loading: false
      },
      // 删除任务
      deleteTaskForm: {
        taskId: null,
        operationCode: null,
        operatorId: null,
        remark: '删除任务'
      },
      quickNotes: [],
      // 自定义签名上传的取消
      source: null,
    };
  },
  // =========================================================== 方法 =============================================================
  methods: {
    // ============================== 文件上传 ==============================
    onUploadSuccess(response, file, fileList) {
      //console.log(response);
      if (response.code !== 20000) {
        messageInfo({type: 'error', message: '上传失败'});
        //console.log(fileList);
        fileList.pop();
        return;
      }
      this.pushForm.withFile = true;
      if (this.pushForm.fileLogIds === "") {
        // console.log(response)
        this.pushForm.fileLogIds = response.data.id;
      } else {
        this.pushForm.fileLogIds = this.pushForm.fileLogIds + '/' + response.data.id;
      }
    },
    // 仓库文件上传
    onStoreHouseFileSuccess(response, file, fileList) {
      if (response.code !== 20000) {
        messageInfo({type: 'error', message: '上传失败'});
        // console.log(fileList);
        fileList.pop();
      } else {
        // 向后台发送 这个文件是仓库需要的
        forStoreFile(response.data.id + '/' + this.storeHouseFileUpload.type).then(res => {
          if (res.code !== 20000) {
            // console.log(res)
            messageInfo({type: 'error', message: res.message});
          }
        })
      }
    },
    onFileUploadError(error) {
      console.log(error);
    },
    // 检查文件
    checkFile(file) {
      // 将上传的url换成普通的url
      this.uploadUrl = getUploadUrl();
      if (file.size > 1024 * 1024 * 200) {
        messageInfo({type: 'warning', message: '文件大小不可大于200MB'});
        return false;
      }
    },
    removeAuthUpload() {
      // 中断请求
      this.source.cancel();

    },
    handleExceed(files, fileList) {
      messageInfo({type: 'warning', message: '请将上传列表清空后，再尝试上传'})
    },
    // 自定义上传
    handleAuthUpload(option) {

      this.myUpload(
        option,
        err => {
          console.log(err);
          messageInfo({type: 'error', message: err})
        },
        res => {
          // 处理进度条的东西，把进度数据传进去实现进度条走动，传参res应该是这样的类型{percent: 48}
          option.onProgress(res)
        }
      );


    },
    myUpload(option, errCallBack = new Function(), progressCallback = new Function()) {
      console.log(option);
      let auth = {
        'name': option.file.name,
        'length': option.file.size
      };
      let uploadUrl = "";
      let endpoint = "";
      let fileId = "";
      // 获得签名URL
      getAuthURL(auth).then(async res => {
        uploadUrl = res.data.url;
        endpoint = res.data.ossExtranetEndPoint;
        fileId = res.data.fileId;

        let source = axios.CancelToken.source();
        this.source = source;
        // console.log(uploadUrl);

        axios.put(uploadUrl, option.file, {
          headers: {
            "content-type": 'multipart/form-data'
          },
          // 取消请求
          cancelToken: source.token,
          onUploadProgress: function (progressEvent) {
            if (progressEvent.lengthComputable) {
              let percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              progressCallback({percent: percent});
            }
          }
        }).then((res) => {
          // 成功之后
          forStoreFile(fileId + '/' + this.storeHouseFileUpload.type).then(res => {
            if (res.code !== 20000) {
              // console.log(res)
              messageInfo({type: 'error', message: res.message});
            }
          })
          // 动画显示成功
          option.onSuccess(res);
        }).catch(err => {
          source.cancel();
          errCallBack(err);

        });
      });
    },
    // ============================== 任务数据 ==============================
    initTask() {
      // this.searchCondition.isFinished = false;
      // this.searchCondition.taskName = '';
      this.loading = true;
      // console.log(this.searchCondition)
      listTask(this.searchCondition).then(res => {
        //console.log(res.data)
        // 将共 total 条数据 更新
        this.total = res.data.total;
        // 处理数据 任务状态 isFinished isStarted
        this.taskList = this.taskListProcessing(res.data.data);
      });
      this.loading = false;
    },
    clearTaskName() {
      this.searchCondition.taskName = '';
      this.searchTask();
    },
    clearTaskStatus() {
      this.searchCondition.isFinished = false;
      this.searchTask();
    },
    // 分页的大小变化
    sizeChange(size) {
      this.searchCondition.size = size;
      this.initTask();
    },
    currentChange(current) {
      this.searchCondition.current = current;
      this.initTask();
    },
    searchTask() {
      // // 使得当前页面为 1 ，否则当 查询的结果不足当前页数，会无法显示
      this.searchCondition.current = 1;
      this.loading = true;
      // console.log(this.searchCondition)
      listTask(this.searchCondition).then(res => {
        //console.log(res.data)
        // 将共 total 条数据 更新
        this.total = res.data.total;
        // 处理数据 任务状态 isFinished isStarted
        this.taskList = this.taskListProcessing(res.data.data);
        this.loading = false;
      });
    },
    taskListProcessing(data) {
      for (let i = 0; i < data.length; i++) {
        // 状态字段名为 status
        let task = data[i];
        if (task.underReview === true) {
          data[i].status = "审核中";
        } else if (task.isStarted === false) {
          data[i].status = "未开始";
          // 如果是
          if (this.userInfo.consumerLevel === '设计') {
            data[i].name = "未知";
            data[i].remark = "未知";
          }
        } else if (task.isFinished === false) {
          data[i].status = "进行中";
        } else {
          data[i].status = "已结束";
        }
      }
      //console.log(data)
      return data;
    },
    clearPushForm() {
      this.$refs.upload.clearFiles();
      this.pushForm.operationCode = '';
      this.pushForm.operatorId = '';
      this.pushForm.remark = '';
      this.pushForm.withFile = false;
      this.pushForm.fileName = '';
      this.pushForm.fileLogIds = '';
    },
    publishTask() {
      if (this.publishTaskForm.receiverId === null) {
        messageInfo({type: 'error', message: '不可选择“所有用户”'});
        return;
      }
      // 将操作者id、name 写上
      this.publishTaskForm.operatorId = this.userInfo.userId;
      this.publishTaskForm.publisherName = this.userInfo.username;
      // 备注 = 原备注 + ‘；’ + 快捷备注
      // console.log(this.publishTaskForm.quickNoteId);
      this.publishTaskForm.remark = this.publishTaskForm.remark + ">|<" + this.getQuickNoteById(this.publishTaskForm.quickNoteId)

      if (strIsEmpty(this.publishTaskForm.name) || strIsEmpty(this.publishTaskForm.remark)) {
        // 如果为空，就显示信息
        messageInfo({type: 'error', message: '用户名与备注不可为空'});
        // 保持窗口显示
        this.publishDialogFormVisible = true;
        // 返回
        return;
      }
      // console.log(this.publishTaskForm)
      taskPublish(this.publishTaskForm).then(res => {
        if (res.code === 20000) {
          // 将值归为 空字符串
          this.publishTaskForm.name = '';
          this.publishTaskForm.remark = '';
          messageInfo({type: 'success', message: res.message});
        }
        // 更新任务列表
        this.initTask();
      });
    },
    getQuickNoteById(ids) {
      let temp = this.quickNotes;
      let str = '';
      for (let i = 0; i < ids.length; i++) {
        for (let j = 0; j < temp.length; j++) {
          if (ids[i] === temp[j].id) {
            str += temp[j].content + '；';
            break;
          }
        }
      }
      if (strIsEmpty(str)) {
        return '；' + str;
      } else {
        return str;
      }
    },
    deleteTask(data) {
      this.deleteTaskForm.operationCode = '4';
      this.deleteTaskForm.operatorId = this.userInfo.userId;
      this.deleteTaskForm.taskId = data.id;
      this.$confirm('此操作将删除任务：' + data.name + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTask(this.deleteTaskForm).then(res => {
          messageInfo({type: 'success', message: res.message});
          // 更新任务列表
          this.initTask();
        })
      }).catch(() => {
        // messageInfo({type: 'info', message: '已取消删除'});
      });
    },
    startTask(data) {
      this.pushForm.operationCode = '9';
      this.pushForm.operatorId = this.userInfo.userId;
      this.pushForm.remark = "任务开始";
      this.pushForm.taskId = data.id;
      pushTask(this.pushForm).then(res => {
        resultCheck(res, true);
        this.clearPushForm();
        this.initTask()
      });
    },
    // ============================== 获得用户id与name =============================
    getConsumerNameAndId() {
      let userList = [];
      if (this.consumerNameAndId.hasList === false) {
        getRequest("/getUserNameAndIdList").then(res => {
          for (let i = 0; i < res.data.length; i++) {
            let user = res.data[i];
            userList.push(user);
          }
          this.consumerNameAndId.list = userList;
          this.consumerNameAndId.hasList = true;
        });
      } else {
        for (let i = 0; i < this.consumerNameAndId.list.length; i++) {
          let user = this.consumerNameAndId.list[i];
          userList.push(user);
        }
      }
      // console.log(userList)
      return userList;
    },
    setConsumerNameAndIdForSearch() {
      // loading
      this.consumerNameAndIdForSearch.loading = true;
      if (this.consumerNameAndIdForSearch.hasList === false) {
        let allUsers = {'userId': -1, 'nickname': '所有用户'};
        let nullValue = {'userId': null, 'nickname': '公海'};
        // 调用函数
        let userList = this.getConsumerNameAndId();
        userList.push(allUsers);
        userList.push(nullValue);
        this.consumerNameAndIdForSearch.list = userList;
        this.consumerNameAndIdForSearch.hasList = true;
      }
      // loading 结束
      this.consumerNameAndIdForSearch.loading = false;
    },
    setConsumerNameAndIdForPublish() {
      // loading
      this.consumerNameAndIdForPublish.loading = true;
      let userList = [];
      if (this.consumerNameAndIdForPublish.hasList === false) {
        let notSpecify = {'userId': -1, 'nickname': '由系统分配'};
        // 调用函数
        if (this.userInfo.consumerLevel === '超级管理员' || this.userInfo.consumerLevel === '管理员' || this.userInfo.consumerLevel === '客服主管') {
          // 只有管理员与超级管理员可以选择人
          userList = this.getConsumerNameAndId()
          // console.log(userList)
        }
        userList.push(notSpecify);
        this.consumerNameAndIdForPublish.list = userList;
        this.consumerNameAndIdForPublish.hasList = true;
      }
      // loading 结束
      this.consumerNameAndIdForPublish.loading = false;
    },
    setGroupForPublish() {
      // loading
      this.groupForPublish.loading = true;
      let groupList = [];
      if (this.groupForPublish.hasList === false) {
        // 调用函数
        groupList = this.getGroup()
        this.groupForPublish.list = groupList;
        // console.log(this.groupForPublish);
        this.groupForPublish.hasList = true;
      }
      // loading 结束
      this.groupForPublish.loading = false;
    },
    getGroup() {
      let groupList = [];
      getRequest("/group/all").then(res => {
        for (let i = 0; i < res.data.length; i++) {
          let group = res.data[i];
          groupList.push(group);
        }
      });
      return groupList;
    },
    // ============================== 任务日志 =============================
    showTaskLog(data) {

      this.taskLogs.list = [];
      listTaskLog({taskId: data.id}).then(res => {
        let tempList = [];
        for (let i = 0; i < res.data.length; i++) {
          let log = res.data[i];
          // console.log(log)
          let content = log.remark;
          let operatorName = log.operatorName;
          let operationName = log.operationName;
          let timestamp = log.gmtCreate;
          let color = this.getColorByOperationCode(log.operation);
          let withFile = log.withFile;
          let fileLogIdList = log.fileLogIdList;
          let success = "（失败）";
          if (log.successful === true) {
            success = "（成功）"
          }

          tempList.push({
            'content': content,
            'operatorName': operatorName,
            'operationName': operationName,
            "timestamp": timestamp,
            'color': color,
            'withFile': withFile,
            'fileLogIdList': fileLogIdList,
            'success': success
          });
        }
        this.taskLogs.list = tempList;
      });
    },
    getColorByOperationCode(code) {
      if (code === 0) {
        // 推进
        return "#3b99e7";
      } else if (code === 1) {
        // 备注
        return "#69716e";
      } else if (code === 2) {
        // 完成
        return "#3ec95d";
      } else if (code === 3) {
        // 开始
        return "#e5ae36";
      }
      return "primary";
    },
    setPushDialog(data) {
      if (this.forReview !== false) {
        this.pushForm.operationCode = '2';
      } else if (this.isOrdinaryConsumer === true) {
        this.pushForm.operationCode = '6';
      } else {
        this.pushForm.operationCode = '1';
      }
      this.pushForm.taskId = data.id;
      this.pushTaskName = data.name;

      this.pushDialogFormVisible = true;
    },
    push() {
      // 将操作人id
      this.pushForm.operatorId = this.$store.state.userInfo.userId;
      if (this.pushForm.remark === "" || this.pushForm.operationCode === '') {
        messageInfo({type: "error", message: "操作、备注不可为空"});
        this.pushDialogFormVisible = true;
        return;
      }
      if (this.pushForm.operationCode === '0' && this.pushForm.withFile === false) {
        messageInfo({type: "error", message: "推进操作必须带有文件"});
        this.pushDialogFormVisible = true;
        return;
      }
      // 发送post请求
      pushTask(this.pushForm).then(res => {
        resultCheck(res, true);
        this.clearPushForm();
        this.initTask();
      });
    },
    downLoadFileInTask(id) {
      // downLoadFile(id).then(res => {
      //   var downloadElement = document.createElement("a");
      //   downloadElement.href = res.data.downloadUrl;
      //   downloadElement.target = "_blank"
      //   downloadElement.download = res.data.fileName;
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click();
      //   document.body.removeChild(downloadElement);
      // });
      getDownloadUrlNotDecreaseScore(id).then(res => {
        let url = res.data.downloadUrl;
        // console.log(url)
        var downloadElement = document.createElement("a");

        downloadElement.href = url;
        downloadElement.target = "_blank"
        // downloadElement.download = this.fileList[index].name;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        // 刷新未下载的
        this.initFile();
      });

    },
    getQuickNotes() {
      listQuickNotes().then(res => {
        // console.log(res.data);
        this.quickNotes = res.data;
      });
    },
    // 更换颜色
    colorChange(row) {
      let form = {};
      form.id = row.id;
      form.color = this.tempColor;
      // console.log(row);
      updateTaskSetting(form).then(res => {
        // console.log(res);
        this.initTask();
      });
      // 每次修改完后就透明
      this.tempColor = "rgba(255,255,255,0)"
    },
    // 每行的style
    rowStyle({row, rowIndex}) {

      let rowBackGround = {};
      // 背景颜色
      rowBackGround.background = row.color;
      return rowBackGround;

    },
    // 一键复制成功
    onCopySuccess() {
      messageInfo({type: 'success', message: '已复制到粘贴板'})
    }
  }
}
</script>

<style scoped>
.page {
  margin-top: 10px;
  display: flex;
  justify-content: right;
}
</style>



// WEBPACK FOOTER //
// src/views/functions/task/MyTask.vue